export default __webpack_public_path__ + "assets/front/scss/formulaire.0a67bf2379023b3e846812c5ba85a164.css";